export const GET_FILETR_LIST_REQUEST = "GET_FILETR_LIST_REQUEST";
export const GET_FILETR_LIST_SUCCESS = "GET_FILETR_LIST_SUCCESS";
export const GET_FILETR_LIST_FAILURE = "GET_FILETR_LIST_FAILURE";

export const GET_MSG_BOARD_FILTER_REQEUST = "GET_MSG_BOARD_FILTER_REQEUST";
export const GET_MSG_BOARD_FILTER_SUCCESS = "GET_MSG_BOARD_FILTER_SUCCESS";
export const GET_MSG_BOARD_FILTER_FAILURE = "GET_MSG_BOARD_FILTER_FAILURE";
